import { useQuery } from "react-query";
import axios from "infra/http";
import { NumeroMensagemTipoDestinoResponse } from "../../portaria/typings";
import { TipoDestinoEnum } from 'core/features/documentos/enums';

function useNumeroMensagensTipoDestino(tipoDestinoId: TipoDestinoEnum, refetchInterval?: number) {
  return useQuery(`/v1/mensagem/numero-mensagens/${tipoDestinoId}`, async () => {
    const { data } = await axios.get<NumeroMensagemTipoDestinoResponse>(
      `/v1/mensagem/numero-mensagens/${tipoDestinoId}`,
    );

    return data;
  }, {
    refetchInterval
  });
}

export default useNumeroMensagensTipoDestino;